import { CheckCircle2, Circle, Copy } from "lucide-react";
import { toast } from "sonner";

const copy = (v, l) => navigator.clipboard?.writeText(v).then(() => toast.success(l || "Copied"));

export function RzpTracker({ st, stats }) {
  const steps = [
    ["Test keys saved", st.test.has_secret], ["Test keys verified", !!st.test.verified_at], ["Webhook received", !!st.test.webhook_ok_at],
    ["Test payment passed", stats.test.paid > 0], ["Live keys verified", !!st.live.verified_at], ["Live payments on", st.active_mode === "live"],
  ];
  return (
    <ol className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-2" data-testid="rzp-tracker">
      {steps.map(([l, d], i) => (
        <li key={l} className={`rounded-xl border p-3 ${d ? "border-emerald-200 bg-emerald-50/60" : "bg-white"}`} data-testid={`rzp-step-${i + 1}`}>
          {d ? <CheckCircle2 className="w-5 h-5 text-emerald-600" /> : <Circle className="w-5 h-5 text-slate-300" />}
          <p className="text-[11px] text-slate-400 mt-1">Step {i + 1}</p><p className="text-sm font-semibold text-[#062a20]">{l}</p>
        </li>))}
    </ol>);
}

export function RzpGuide({ guide, webhookUrl, events }) {
  return (
    <div className="space-y-3" data-testid="rzp-guide">
      <div className="rounded-xl border border-[#c9a13b]/50 bg-[#fffdf7] p-4 space-y-2">
        <p className="font-semibold text-[#062a20]">Your Altiora webhook URL</p>
        <div className="flex flex-wrap items-center gap-2"><code className="text-xs bg-white border rounded px-2 py-1 break-all" data-testid="gateway-webhook-url">{webhookUrl}</code>
          <button onClick={() => copy(webhookUrl, "Webhook URL copied")} className="btn-gold !py-1.5 !text-xs" data-testid="gateway-webhook-copy"><Copy className="w-3.5 h-3.5" />Copy</button></div>
        <p className="text-xs text-slate-600">Paste into <b>Webhook URL</b> in Razorpay. Then tick these events:</p>
        <div className="flex flex-wrap items-center gap-1.5">{events.map((e) => <code key={e} className="text-[11px] bg-white border rounded px-1.5 py-0.5">{e}</code>)}
          <button onClick={() => copy(events.join(", "), "Events copied")} className="chip !py-1 !text-xs" data-testid="rzp-events-copy"><Copy className="w-3 h-3" />Copy list</button></div>
      </div>
      {guide.map((s, i) => (
        <details key={s.key || s.title} className="rounded-xl border p-3" open={i < 1} data-testid={`rzp-guide-${s.key || i}`}>
          <summary className="cursor-pointer font-semibold text-[#062a20] text-sm">{i + 1}. {s.title}</summary>
          <ol className="list-decimal pl-5 mt-2 space-y-1 text-sm text-slate-700">{s.steps.map((x) => <li key={x}>{x}</li>)}</ol>
        </details>))}
      <p className="text-xs text-slate-500">Razorpay changes its menus from time to time. If something looks different, search Razorpay's help pages for "API keys" or "webhooks".</p>
    </div>);
}
